export default __webpack_public_path__ + "static/media/icon-close.d5ba0dc5.svg";